import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';

import {vendorCodes} from 'modules/store/vendors';

import {invalidateAccounts} from 'modules/store/accounts';
import {TIMEOUT_STORE} from 'util/constants';

const
    mapFields = {
        account_id: 'accountId'
    },
    transformEntitiesFn = account => {
        if (typeof account !== 'object') {
            throw new Error('transformAws needs an object to transform');
        }

        return {
            id:        account.id,
            name:      account.alias,
            reselling: account.reselling,
            msp:       account.msp,
            vendor:    {
                selected: vendorCodes.aws,
                values:   {
                    accountId: account.account_id
                }
            }
        };

    },
    transformEntitiesToSaveFn = account => Object.keys(account.vendor)
        .reduce((ret, key) => ({
            ...ret,
            account_id: account.vendor.accountId
        }), {
            name: account.name
        });

const exports = storeModuleFactory({
    name:             'awsAccounts',
    endpoint:         endpoints.accounts.aws.endpoint,
    instanceEndpoint: endpoints.accounts.aws.instanceEndpoint,
    callbackActions:  [{
        method: 'update',
        action: invalidateAccounts
    }],
    timeout: TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
    transformEntitiesFn,
    transformEntitiesToSaveFn
});

exports.transformEntitiesFn = transformEntitiesFn;
exports.transformEntitiesToSaveFn = transformEntitiesToSaveFn;
exports.mapFields = mapFields;

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/awsAccounts.js